export const appLocaleStorageKey = '@12KXJCUUCUU'
